// extracted by mini-css-extract-plugin
module.exports = {"loader":"ButtonLoader_loader___gexQ","blink":"ButtonLoader_blink__eOZPy"};